import { useRef, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { IoArrowUpCircle } from "react-icons/io5";
import { Dropzone } from "../styles/styles";
import {
  StyledButtonOuter,
  StyledButtonInnerUploadImageView,
  StyledImageContainer,
  StyledUploadContainer,
  StyledTopContent,
} from "../../../components/styles/containers/Containers";
import { StyledButtonAddImg } from "../../../components/styles/buttons/Buttons";
import Error from "../../../components/errors/Error";

const UploadImageForm = ({ onImagesAdd, errorMessage }) => {
  const fileInput = useRef(null);
  const onDrop = useCallback(
    (acceptedFiles) => {
      onImagesAdd(acceptedFiles);
    },
    [onImagesAdd]
  ); // Ingen lokal validering, skickar vidare
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const handleKeyUp = (event) => {
    //console.log("hepp", event);
    if (event.key == " ") {
      document.getElementById("upload-button-view").click();
    }
  };
  return (
    <StyledUploadContainer>
      <StyledTopContent>
        <Dropzone
          {...getRootProps()}
          onKeyUp={handleKeyUp}
          role="button"
          aria-roledescription="Klicka eller dra hit en bild"
          style={{ marginBottom: "0px" }}
        >
          <input
            name="images"
            type="file"
            id="upload-button"
            multiple
            ref={fileInput}
            style={{ display: "none" }}
            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
            {...getInputProps()}
          />
          <IoArrowUpCircle
            size="3rem"
            style={{ color: "#037540", marginBottom: "10px" }}
          />
          Klicka eller dra hit för att starta uppladdning
        </Dropzone>
        {errorMessage && <Error errorMessage={errorMessage} />}
      </StyledTopContent>
      <StyledImageContainer>
        <StyledButtonOuter>
          <StyledButtonInnerUploadImageView>
            <StyledButtonAddImg {...getRootProps()}>
              <input
                name="images"
                type="file"
                id="upload-button-view"
                multiple
                ref={fileInput}
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                {...getInputProps()}
              />
              Lägg till bild
            </StyledButtonAddImg>
          </StyledButtonInnerUploadImageView>
        </StyledButtonOuter>
      </StyledImageContainer>
    </StyledUploadContainer>
  );
};

export default UploadImageForm;
